import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./side-menu.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./side-menu.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/js/components/side-menu/side-menu.vue?vue&type=script&lang=js
// module id = ./src/js/components/side-menu/side-menu.vue?vue&type=script&lang=js
// module chunks = 4